// gc_i18n 仅扫描源码文件，使用 getter 让区号文案参与收集并在渲染时读取当前语言。
const codeData = [{
  get title() {
    return $t("k3tslt9", "# 热门国家或地区");
  },
  items: [{
    id: "+86",
    get name() {
      return $t("a85gtr4", "中国大陆");
    }
  }, {
    id: "+852",
    get name() {
      return $t("a8g7ja4", "中国香港");
    }
  }, {
    id: "+853",
    get name() {
      return $t("a89ath4", "中国澳门");
    }
  }, {
    id: "+886",
    get name() {
      return $t("a84d1a4", "中国台湾");
    }
  }]
}, {
  get title() {
    return "A";
  },
  items: [{
    id: "+376",
    get name() {
      return $t("e3pt63", "安道尔");
    }
  }, {
    id: "+971",
    get name() {
      return $t("yericw8", "阿拉伯联合酋长国");
    }
  }, {
    id: "+93",
    get name() {
      return $t("mggay3", "阿富汗");
    }
  }, {
    id: "+1",
    get name() {
      return $t("4btec87", "安提瓜和巴布达");
    }
  }, {
    id: "+1",
    get name() {
      return $t("du16t3", "安圭拉");
    }
  }, {
    id: "+355",
    get name() {
      return $t("v7x0ql5", "阿尔巴尼亚");
    }
  }, {
    id: "+244",
    get name() {
      return $t("dtn7x3", "安哥拉");
    }
  }, {
    id: "+54",
    get name() {
      return $t("mihr13", "阿根廷");
    }
  }, {
    id: "+43",
    get name() {
      return $t("dinmm3", "奥地利");
    }
  }, {
    id: "+61",
    get name() {
      return $t("egn42t4", "澳大利亚");
    }
  }, {
    id: "+297",
    get name() {
      return $t("mrdoy3", "阿鲁巴");
    }
  }, {
    id: "+358",
    get name() {
      return $t("bmg9r64", "奥兰群岛");
    }
  }, {
    id: "+994",
    get name() {
      return $t("jbmzjd4", "阿塞拜疆");
    }
  }, {
    id: "+213",
    get name() {
      return $t("v6dpmu5", "阿尔及利亚");
    }
  }, {
    id: "+372",
    get name() {
      return $t("euuqna4", "爱沙尼亚");
    }
  }, {
    id: "+20",
    get name() {
      return $t("fdyf2", "埃及");
    }
  }, {
    id: "+251",
    get name() {
      return $t("iuk0h5", "埃塞俄比亚");
    }
  }, {
    id: "+353",
    get name() {
      return $t("h68jx3", "爱尔兰");
    }
  }, {
    id: "+968",
    get name() {
      return $t("q4d92", "阿曼");
    }
  }]
}, {
  get title() {
    return "B";
  },
  items: [{
    id: "+387",
    get name() {
      return $t("tfcbc6a", "波斯尼亚和黑塞哥维那");
    }
  }, {
    id: "+1",
    get name() {
      return $t("c8sx1x4", "巴巴多斯");
    }
  }, {
    id: "+32",
    get name() {
      return $t("g73y93", "比利时");
    }
  }, {
    id: "+226",
    get name() {
      return $t("o20bah5", "布基纳法索");
    }
  }, {
    id: "+359",
    get name() {
      return $t("af4px04", "保加利亚");
    }
  }, {
    id: "+973",
    get name() {
      return $t("gjs32", "巴林");
    }
  }, {
    id: "+257",
    get name() {
      return $t("ei44n3", "布隆迪");
    }
  }, {
    id: "+229",
    get name() {
      return $t("oi6c2", "贝宁");
    }
  }, {
    id: "+1",
    get name() {
      return $t("htunk3", "百慕大");
    }
  }, {
    id: "+591",
    get name() {
      return $t("ey4tis4", "玻利维亚");
    }
  }, {
    id: "+55",
    get name() {
      return $t("gqh72", "巴西");
    }
  }, {
    id: "+1",
    get name() {
      return $t("e6oig3", "巴哈马");
    }
  }, {
    id: "+975",
    get name() {
      return $t("dpe42", "不丹");
    }
  }, {
    id: "+267",
    get name() {
      return $t("b28zyz4", "博茨瓦纳");
    }
  }, {
    id: "+375",
    get name() {
      return $t("fab6n34", "白俄罗斯");
    }
  }, {
    id: "+501",
    get name() {
      return $t("bzye73", "伯利兹");
    }
  }, {
    id: "+354",
    get name() {
      return $t("eei32", "冰岛");
    }
  }, {
    id: "+1",
    get name() {
      return $t("5qpd8n7", "北马里亚纳群岛");
    }
  }, {
    id: "+507",
    get name() {
      return $t("e93k13", "巴拿马");
    }
  }, {
    id: "+51",
    get name() {
      return $t("ll0p2", "秘鲁");
    }
  }, {
    id: "+675",
    get name() {
      return $t("cp9dc7", "巴布亚新几内亚");
    }
  }, {
    id: "+92",
    get name() {
      return $t("c7zgrh4", "巴基斯坦");
    }
  }, {
    id: "+48",
    get name() {
      return $t("iytq2", "波兰");
    }
  }, {
    id: "+1",
    get name() {
      return $t("e47jam4", "波多黎各");
    }
  }, {
    id: "+970",
    get name() {
      return $t("c789yt4", "巴勒斯坦");
    }
  }, {
    id: "+595",
    get name() {
      return $t("e8ozc3", "巴拉圭");
    }
  }]
}, {
  get title() {
    return "C";
  },
  items: [{
    id: "+240",
    get name() {
      return $t("34u6rq5", "赤道几内亚");
    }
  }]
}, {
  get title() {
    return "D";
  },
  items: [{
    id: "+49",
    get name() {
      return $t("grae2", "德国");
    }
  }, {
    id: "+246",
    get name() {
      return $t("4o9fj6", "迭戈·加西亚");
    }
  }, {
    id: "+45",
    get name() {
      return $t("e6bx2", "丹麦");
    }
  }, {
    id: "+1",
    get name() {
      return $t("br93hk4", "多米尼克");
    }
  }, {
    id: "+1",
    get name() {
      return $t("gwlol7", "多米尼加共和国");
    }
  }, {
    id: "+228",
    get name() {
      return $t("fmdn2", "多哥");
    }
  }, {
    id: "+670",
    get name() {
      return $t("bwh053", "东帝汶");
    }
  }]
}, {
  get title() {
    return "E";
  },
  items: [{
    id: "+593",
    get name() {
      return $t("b0rifm4", "厄瓜多尔");
    }
  }, {
    id: "+291",
    get name() {
      return $t("cmy4rk5", "厄立特里亚");
    }
  }, {
    id: "+7",
    get name() {
      return $t("catj03", "俄罗斯");
    }
  }]
}, {
  get title() {
    return "F";
  },
  items: [{
    id: "+238",
    get name() {
      return $t("c3gdy3", "佛得角");
    }
  }, {
    id: "+358",
    get name() {
      return $t("mo902", "芬兰");
    }
  }, {
    id: "+679",
    get name() {
      return $t("hvi62", "斐济");
    }
  }, {
    id: "+500",
    get name() {
      return $t("bbmtyt5", "福克兰群岛");
    }
  }, {
    id: "+298",
    get name() {
      return $t("e9flzt4", "法罗群岛");
    }
  }, {
    id: "+33",
    get name() {
      return $t("izm02", "法国");
    }
  }, {
    id: "+594",
    get name() {
      return $t("bczxwt5", "法属圭亚那");
    }
  }, {
    id: "+689",
    get name() {
      return $t("6oeczd7", "法属波利尼西亚");
    }
  }, {
    id: "+63",
    get name() {
      return $t("jshz93", "菲律宾");
    }
  }, {
    id: "+39",
    get name() {
      return $t("fz3qz3", "梵蒂冈");
    }
  }]
}, {
  get title() {
    return "G";
  },
  items: [{
    id: "+243",
    get name() {
      return $t("k0hbc25", "刚果（金）");
    }
  }, {
    id: "+242",
    get name() {
      return $t("k0q4k45", "刚果（布）");
    }
  }, {
    id: "+57",
    get name() {
      return $t("b1l6934", "哥伦比亚");
    }
  }, {
    id: "+506",
    get name() {
      return $t("9scrtm5", "哥斯达黎加");
    }
  }, {
    id: "+1",
    get name() {
      return $t("dl2ydi4", "格林纳达");
    }
  }, {
    id: "+995",
    get name() {
      return $t("dsmcs64", "格鲁吉亚");
    }
  }, {
    id: "+44",
    get name() {
      return $t("dk2nhl4", "格恩西岛");
    }
  }, {
    id: "+299",
    get name() {
      return $t("fznx33", "格陵兰");
    }
  }, {
    id: "+220",
    get name() {
      return $t("cgoni3", "冈比亚");
    }
  }, {
    id: "+590",
    get name() {
      return $t("f590uq4", "瓜德罗普");
    }
  }, {
    id: "+1",
    get name() {
      return $t("ed1k2", "关岛");
    }
  }, {
    id: "+592",
    get name() {
      return $t("d5u7q3", "圭亚那");
    }
  }]
}, {
  get title() {
    return "H";
  },
  items: [{
    id: "+599",
    get name() {
      return $t("uf5ezl6", "荷属加勒比区");
    }
  }, {
    id: "+504",
    get name() {
      return $t("ede34p4", "洪都拉斯");
    }
  }, {
    id: "+509",
    get name() {
      return $t("j3ix2", "海地");
    }
  }, {
    id: "+82",
    get name() {
      return $t("qbec2", "韩国");
    }
  }, {
    id: "+7",
    get name() {
      return $t("6ncnr25", "哈萨克斯坦");
    }
  }, {
    id: "+382",
    get name() {
      return $t("rirk2", "黑山");
    }
  }, {
    id: "+31",
    get name() {
      return $t("mt3t2", "荷兰");
    }
  }]
}, {
  get title() {
    return "J";
  },
  items: [{
    id: "+1",
    get name() {
      return $t("cl0a03", "加拿大");
    }
  }, {
    id: "+420",
    get name() {
      return $t("hd4k2", "捷克");
    }
  }, {
    id: "+253",
    get name() {
      return $t("crnjq3", "吉布提");
    }
  }, {
    id: "+241",
    get name() {
      return $t("es7g2", "加蓬");
    }
  }, {
    id: "+233",
    get name() {
      return $t("eqz72", "加纳");
    }
  }, {
    id: "+224",
    get name() {
      return $t("ce0t13", "几内亚");
    }
  }, {
    id: "+245",
    get name() {
      return $t("oeppo25", "几内亚比绍");
    }
  }, {
    id: "+996",
    get name() {
      return $t("qpnw546", "吉尔吉斯斯坦");
    }
  }, {
    id: "+855",
    get name() {
      return $t("fnf5s3", "柬埔寨");
    }
  }, {
    id: "+686",
    get name() {
      return $t("bpa66l4", "基里巴斯");
    }
  }, {
    id: "+263",
    get name() {
      return $t("e5t90y4", "津巴布韦");
    }
  }]
}, {
  get title() {
    return "K";
  },
  items: [{
    id: "+61",
    get name() {
      return $t("9xijcm9", "科科斯（基林）群岛");
    }
  }, {
    id: "+225",
    get name() {
      return $t("ful4as4", "科特迪瓦");
    }
  }, {
    id: "+682",
    get name() {
      return $t("c9y6xb4", "库克群岛");
    }
  }, {
    id: "+237",
    get name() {
      return $t("danfk3", "喀麦隆");
    }
  }, {
    id: "+599",
    get name() {
      return $t("ec6do3", "库拉索");
    }
  }, {
    id: "+385",
    get name() {
      return $t("as71zq4", "克罗地亚");
    }
  }, {
    id: "+254",
    get name() {
      return $t("janyl3", "肯尼亚");
    }
  }, {
    id: "+269",
    get name() {
      return $t("ic42n3", "科摩罗");
    }
  }, {
    id: "+965",
    get name() {
      return $t("ia9t53", "科威特");
    }
  }, {
    id: "+1",
    get name() {
      return $t("cf26434", "开曼群岛");
    }
  }, {
    id: "+974",
    get name() {
      return $t("cn6n53", "卡塔尔");
    }
  }]
}, {
  get title() {
    return "L";
  },
  items: [{
    id: "+856",
    get name() {
      return $t("mbek2", "老挝");
    }
  }, {
    id: "+961",
    get name() {
      return $t("npupv3", "黎巴嫩");
    }
  }, {
    id: "+423",
    get name() {
      return $t("kzxr1e5", "列支敦士登");
    }
  }, {
    id: "+231",
    get name() {
      return $t("atjw494", "利比里亚");
    }
  }, {
    id: "+266",
    get name() {
      return $t("jw89z3", "莱索托");
    }
  }, {
    id: "+370",
    get name() {
      return $t("ipkvk3", "立陶宛");
    }
  }, {
    id: "+352",
    get name() {
      return $t("cq09h3", "卢森堡");
    }
  }, {
    id: "+371",
    get name() {
      return $t("d02w8e4", "拉脱维亚");
    }
  }, {
    id: "+218",
    get name() {
      return $t("ck01b3", "利比亚");
    }
  }, {
    id: "+262",
    get name() {
      return $t("hn1zb3", "留尼汪");
    }
  }, {
    id: "+40",
    get name() {
      return $t("gp9n6b4", "罗马尼亚");
    }
  }, {
    id: "+250",
    get name() {
      return $t("cpt5y3", "卢旺达");
    }
  }]
}, {
  get title() {
    return "M";
  },
  items: [{
    id: "+1",
    get name() {
      return $t("dpyay15", "美属萨摩亚");
    }
  }, {
    id: "+880",
    get name() {
      return $t("bvgoqd4", "孟加拉国");
    }
  }, {
    id: "+691",
    get name() {
      return $t("m4jpdx6", "密克罗尼西亚");
    }
  }, {
    id: "+44",
    get name() {
      return $t("n364e3", "马恩岛");
    }
  }, {
    id: "+212",
    get name() {
      return $t("f8hg33", "摩洛哥");
    }
  }, {
    id: "+377",
    get name() {
      return $t("fbh6j3", "摩纳哥");
    }
  }, {
    id: "+373",
    get name() {
      return $t("d1ulg74", "摩尔多瓦");
    }
  }, {
    id: "+261",
    get name() {
      return $t("h0fy5d5", "马达加斯加");
    }
  }, {
    id: "+692",
    get name() {
      return $t("j3uwvq5", "马绍尔群岛");
    }
  }, {
    id: "+389",
    get name() {
      return $t("n0yet3", "马其顿");
    }
  }, {
    id: "+223",
    get name() {
      return $t("r2e82", "马里");
    }
  }, {
    id: "+95",
    get name() {
      return $t("m8yb2", "缅甸");
    }
  }, {
    id: "+976",
    get name() {
      return $t("n0iz2", "蒙古");
    }
  }, {
    id: "+596",
    get name() {
      return $t("jw8lf74", "马提尼克");
    }
  }, {
    id: "+222",
    get name() {
      return $t("ead5c15", "毛里塔尼亚");
    }
  }, {
    id: "+1",
    get name() {
      return $t("yzcxg25", "蒙特塞拉特");
    }
  }, {
    id: "+356",
    get name() {
      return $t("n8i273", "马耳他");
    }
  }, {
    id: "+230",
    get name() {
      return $t("e7m20u4", "毛里求斯");
    }
  }, {
    id: "+960",
    get name() {
      return $t("jv1l1s4", "马尔代夫");
    }
  }, {
    id: "+265",
    get name() {
      return $t("n3rg73", "马拉维");
    }
  }, {
    id: "+52",
    get name() {
      return $t("dnc323", "墨西哥");
    }
  }, {
    id: "+60",
    get name() {
      return $t("jwz60k4", "马来西亚");
    }
  }, {
    id: "+258",
    get name() {
      return $t("h1nla54", "莫桑比克");
    }
  }, {
    id: "+1",
    get name() {
      return $t("m69b2", "美国");
    }
  }, {
    id: "+1",
    get name() {
      return $t("npaos37", "美属维尔京群岛");
    }
  }, {
    id: "+262",
    get name() {
      return $t("n8flr3", "马约特");
    }
  }]
}, {
  get title() {
    return "N";
  },
  items: [{
    id: "+264",
    get name() {
      return $t("gi1j6u4", "纳米比亚");
    }
  }, {
    id: "+227",
    get name() {
      return $t("e06q33", "尼日尔");
    }
  }, {
    id: "+672",
    get name() {
      return $t("i5s75x4", "诺福克岛");
    }
  }, {
    id: "+234",
    get name() {
      return $t("c24j964", "尼日利亚");
    }
  }, {
    id: "+505",
    get name() {
      return $t("bzdyqf4", "尼加拉瓜");
    }
  }, {
    id: "+47",
    get name() {
      return $t("hd072", "挪威");
    }
  }, {
    id: "+977",
    get name() {
      return $t("e1cxy3", "尼泊尔");
    }
  }, {
    id: "+674",
    get name() {
      return $t("knd42", "瑙鲁");
    }
  }, {
    id: "+683",
    get name() {
      return $t("m1eu2", "纽埃");
    }
  }, {
    id: "+211",
    get name() {
      return $t("cu4m93", "南苏丹");
    }
  }, {
    id: "+27",
    get name() {
      return $t("f0872", "南非");
    }
  }]
}, {
  get title() {
    return "P";
  },
  items: [{
    id: "+612",
    get name() {
      return $t("21rhyc6", "皮特凯恩群岛");
    }
  }, {
    id: "+351",
    get name() {
      return $t("k143a3", "葡萄牙");
    }
  }, {
    id: "+680",
    get name() {
      return $t("ggfy2", "帕劳");
    }
  }]
}, {
  get title() {
    return "R";
  },
  items: [{
    id: "+41",
    get name() {
      return $t("ka4t2", "瑞士");
    }
  }, {
    id: "+81",
    get name() {
      return $t("hwbr2", "日本");
    }
  }, {
    id: "+46",
    get name() {
      return $t("k8nu2", "瑞典");
    }
  }]
}, {
  get title() {
    return "S";
  },
  items: [{
    id: "+590",
    get name() {
      return $t("25aq685", "圣巴泰勒米");
    }
  }, {
    id: "+61",
    get name() {
      return $t("dfrog3", "圣诞岛");
    }
  }, {
    id: "+357",
    get name() {
      return $t("bly99k4", "塞浦路斯");
    }
  }, {
    id: "+1",
    get name() {
      return $t("1os2tg7", "圣基茨和尼维斯");
    }
  }, {
    id: "+1",
    get name() {
      return $t("bcj26y4", "圣卢西亚");
    }
  }, {
    id: "+94",
    get name() {
      return $t("dfgiwe4", "斯里兰卡");
    }
  }, {
    id: "+590",
    get name() {
      return $t("bmnlsz4", "圣马丁岛");
    }
  }, {
    id: "+508",
    get name() {
      return $t("mudbmga", "圣皮埃尔和密克隆群岛");
    }
  }, {
    id: "+381",
    get name() {
      return $t("bjc93w4", "塞尔维亚");
    }
  }, {
    id: "+966",
    get name() {
      return $t("dhpc795", "沙特阿拉伯");
    }
  }, {
    id: "+677",
    get name() {
      return $t("pcb5zs5", "所罗门群岛");
    }
  }, {
    id: "+248",
    get name() {
      return $t("dkl0m3", "塞舌尔");
    }
  }, {
    id: "+249",
    get name() {
      return $t("moga2", "苏丹");
    }
  }, {
    id: "+386",
    get name() {
      return $t("ef1uef5", "斯洛文尼亚");
    }
  }, {
    id: "+421",
    get name() {
      return $t("da2mx34", "斯洛伐克");
    }
  }, {
    id: "+232",
    get name() {
      return $t("bk44mc4", "塞拉利昂");
    }
  }, {
    id: "+378",
    get name() {
      return $t("bmonc84", "圣马力诺");
    }
  }, {
    id: "+221",
    get name() {
      return $t("bhl40r4", "塞内加尔");
    }
  }, {
    id: "+252",
    get name() {
      return $t("j2w023", "索马里");
    }
  }, {
    id: "+597",
    get name() {
      return $t("jv09m3", "苏里南");
    }
  }, {
    id: "+239",
    get name() {
      return $t("p5d1zh8", "圣多美和普林西比");
    }
  }, {
    id: "+503",
    get name() {
      return $t("h24gkg4", "萨尔瓦多");
    }
  }, {
    id: "+268",
    get name() {
      return $t("d7blav4", "斯威士兰");
    }
  }, {
    id: "+1",
    get name() {
      return $t("nanxzda", "圣文森特和格林纳丁斯");
    }
  }, {
    id: "+685",
    get name() {
      return $t("jud893", "萨摩亚");
    }
  }]
}, {
  get title() {
    return "T";
  },
  items: [{
    id: "+1",
    get name() {
      return $t("gpditx9", "特克斯和凯科斯群岛");
    }
  }, {
    id: "+66",
    get name() {
      return $t("j0992", "泰国");
    }
  }, {
    id: "+992",
    get name() {
      return $t("15ejm55", "塔吉克斯坦");
    }
  }, {
    id: "+690",
    get name() {
      return $t("esug03", "托克劳");
    }
  }, {
    id: "+993",
    get name() {
      return $t("25gri95", "土库曼斯坦");
    }
  }, {
    id: "+216",
    get name() {
      return $t("ie7g43", "突尼斯");
    }
  }, {
    id: "+676",
    get name() {
      return $t("iw1o2", "汤加");
    }
  }, {
    id: "+90",
    get name() {
      return $t("ddn2a3", "土耳其");
    }
  }, {
    id: "+1",
    get name() {
      return $t("zgsnw38", "特立尼达和多巴哥");
    }
  }, {
    id: "+688",
    get name() {
      return $t("db1ru3", "图瓦卢");
    }
  }, {
    id: "+255",
    get name() {
      return $t("bgkix54", "坦桑尼亚");
    }
  }]
}, {
  get title() {
    return "W";
  },
  items: [{
    id: "+673",
    get name() {
      return $t("hzpm2", "文莱");
    }
  }, {
    id: "+502",
    get name() {
      return $t("awe2gs4", "危地马拉");
    }
  }, {
    id: "+380",
    get name() {
      return $t("bv4r53", "乌克兰");
    }
  }, {
    id: "+256",
    get name() {
      return $t("bxplk3", "乌干达");
    }
  }, {
    id: "+598",
    get name() {
      return $t("by5003", "乌拉圭");
    }
  }, {
    id: "+998",
    get name() {
      return $t("hb3qys6", "乌兹别克斯坦");
    }
  }, {
    id: "+58",
    get name() {
      return $t("bodp244", "委内瑞拉");
    }
  }, {
    id: "+678",
    get name() {
      return $t("f3mejn4", "瓦努阿图");
    }
  }]
}, {
  get title() {
    return "X";
  },
  items: [{
    id: "+34",
    get name() {
      return $t("kpcy33", "西班牙");
    }
  }, {
    id: "+30",
    get name() {
      return $t("gpfi2", "希腊");
    }
  }, {
    id: "+36",
    get name() {
      return $t("cpq0o3", "匈牙利");
    }
  }, {
    id: "+687",
    get name() {
      return $t("z1asqk6", "新喀里多尼亚");
    }
  }, {
    id: "+64",
    get name() {
      return $t("fk1353", "新西兰");
    }
  }, {
    id: "+65",
    get name() {
      return $t("faq9d3", "新加坡");
    }
  }]
}, {
  get title() {
    return "Y";
  },
  items: [{
    id: "+374",
    get name() {
      return $t("ag13pu4", "亚美尼亚");
    }
  }, {
    id: "+44",
    get name() {
      return $t("mqzw2", "英国");
    }
  }, {
    id: "+62",
    get name() {
      return $t("gl19dr5", "印度尼西亚");
    }
  }, {
    id: "+972",
    get name() {
      return $t("c6nbe3", "以色列");
    }
  }, {
    id: "+91",
    get name() {
      return $t("epme2", "印度");
    }
  }, {
    id: "+246",
    get name() {
      return $t("73dmc27", "英属印度洋领地");
    }
  }, {
    id: "+964",
    get name() {
      return $t("c20q43", "伊拉克");
    }
  }, {
    id: "+39",
    get name() {
      return $t("enei93", "意大利");
    }
  }, {
    id: "+1",
    get name() {
      return $t("h4qx53", "牙买加");
    }
  }, {
    id: "+962",
    get name() {
      return $t("m3nk2", "约旦");
    }
  }, {
    id: "+1",
    get name() {
      return $t("yq52ja7", "英属维尔京群岛");
    }
  }, {
    id: "+84",
    get name() {
      return $t("oj652", "越南");
    }
  }, {
    id: "+967",
    get name() {
      return $t("e5ih2", "也门");
    }
  }]
}, {
  get title() {
    return "Z";
  },
  items: [{
    id: "+236",
    get name() {
      return $t("u1ymhb5", "中非共和国");
    }
  }, {
    id: "+56",
    get name() {
      return $t("hvqn2", "智利");
    }
  }, {
    id: "+350",
    get name() {
      return $t("feijyw4", "直布罗陀");
    }
  }, {
    id: "+44",
    get name() {
      return $t("gml6h3", "泽西岛");
    }
  }, {
    id: "+235",
    get name() {
      return $t("ducq2", "乍得");
    }
  }, {
    id: "+260",
    get name() {
      return $t("l87503", "赞比亚");
    }
  }, {
    id: "+86",
    get name() {
      return $t("a85gtr4", "中国大陆");
    }
  }, {
    id: "+852",
    get name() {
      return $t("a8g7ja4", "中国香港");
    }
  }, {
    id: "+853",
    get name() {
      return $t("a89ath4", "中国澳门");
    }
  }, {
    id: "+886",
    get name() {
      return $t("a84d1a4", "中国台湾");
    }
  }]
}];
export default codeData;